<template>
	<div class="commission-page">
		<!-- 汇总 -->
		<div style="margin: 10px 0">
		截至目前：提成总金额 {{ allCount.totalCommissionAmount }}元，新用户首次购买提成{{
			allCount.firstPurchaseAmount
		}}元，拉新者终身提成{{ allCount.lifelongAmount }}元，再次通过分享链接购买提成{{
			allCount.repeatShareAmount
		}}元
		</div>
		<!-- 标签页（对齐钱包统计的tab结构） -->
		<el-tabs v-model="activeTab" @tab-click="changeSelectValue" type="card" class="tab-box">
			<!-- 提成统计 Tab -->
			<el-tab-pane label="提成统计" name="stat">
				<!-- 统计查询区域（对齐钱包统计的查询区域结构） -->
				<div class="query-row">
					<div class="query-item">
						<span>时间:</span>
						<el-date-picker
								v-model="statQuery.dateRange"
								type="daterange"
								range-separator="-"
								separator="至"
								value-format="yyyy-MM-dd"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								clearable
						/>
					</div>
					<div class="query-item">
						<span>金额范围:</span>
						<el-input
								v-model="statQuery.minAmount"
								placeholder="最小金额"
								type="number"
								:min="0"
								clearable
								style="width:150px"
						/>
						<span>-</span>
						<el-input
								v-model="statQuery.maxAmount"
								placeholder="最大金额"
								type="number"
								:min="0"
								clearable
								style="width:150px"
						/>
					</div>
					<el-button type="primary"  @click="resetStatQuery">重置查询条件</el-button>
					<el-button type="primary" @click="fetchStatDataFun">查询</el-button>
				</div>
				
				<!-- 统计表格（对齐钱包统计的表格样式） -->
				<el-table
						:data="statTableData"
						border
						stripe
						header-align="center"
						align="center"
						size="medium"
				>
					<el-table-column prop="dateTime" label="系统日期" header-align="center" align="center"></el-table-column>
					<el-table-column prop="pretaxAmount" label="提成金额(元)" header-align="center" align="center">
						<template slot-scope="scope">
<!--              <div :class="scope.row.pretaxAmount>0? 'text-success' : 'text-danger'">-->
              <div style="padding: 5px 0">
                {{ scope.row.pretaxAmount }}
              </div>
						</template>
					</el-table-column>
					<el-table-column prop="firstAmount" label="新用户首次购买" header-align="center" align="center"></el-table-column>
					<el-table-column prop="lifelongAmount" label="拉新者终身提成" header-align="center" align="center"></el-table-column>
					<el-table-column prop="againAmount" label="再次通过分享链接购买" header-align="center" align="center"></el-table-column>
				</el-table>
				
				<!-- 统计分页（对齐钱包统计的分页参数和结构） -->
				<div class="pager-box">
					<span>共{{ statTotal }}条</span>
					<el-pagination
							:page-sizes="[20,50,100]"
							:page-size="statPage.pageSize"
							:current-page="statPage.pageNum"
							:total="statTotal"
							layout="sizes, prev, pager, next, jumper"
							@size-change="statSizeChange"
							@current-change="statPageChange"
					/>
				</div>
			</el-tab-pane>
			
			<!-- 提成明细 Tab -->
			<el-tab-pane label="提成明细" name="detail">
				<!-- 明细查询区域（对齐钱包明细的查询区域结构） -->
				<div class="query-row detail-query">
					<div class="query-item">
						<span>订单编号:</span>
						<el-input v-model="detailQuery.orderNo" placeholder="请输入订单编号" style="width:160px" clearable />
					</div>
					<div class="query-item">
						<span>用户姓名:</span>
						<el-input v-model="detailQuery.userName" placeholder="请输入用户姓名" style="width:160px" clearable />
					</div>
					<div class="query-item">
						<span>手机号:</span>
						<el-input v-model="detailQuery.phone" placeholder="请输入手机号" style="width:160px" clearable />
					</div>
					<div class="query-item">
						<span>类型:</span>
						<el-select v-model="detailQuery.type" placeholder="请选择" clearable style="width:120px">
							<el-option label="首次消费提成" :value="1"></el-option>
							<el-option label="拉新者终身提成" :value="2"></el-option>
							<el-option label="再次通过分享链接购买" :value="3"></el-option>
							<el-option label="退费回补" :value="4"></el-option>
						</el-select>
					</div>
					<div class="query-item">
						<span>状态:</span>
						<el-select v-model="detailQuery.status" placeholder="请选择" clearable style="width:120px">
							
							<el-option label="预估收入" :value="1"></el-option>
							<el-option label="已入账钱包" :value="2"></el-option>
						</el-select>
					</div>
					<div class="query-item time-box">
						<span>时间:</span>
						<el-button size="mini" @click="setDateRange(-1)">前一天</el-button>
						<el-date-picker
								v-model="detailQuery.dateRange"
								type="daterange"
								range-separator="-"
								separator="至"
								value-format="yyyy-MM-dd"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								clearable
								style="width:280px"
						/>
						<el-button size="mini" @click="setDateRange(1)">后一天</el-button>
					</div>
					<div class="query-item">
						<span>金额范围:</span>
						<el-input v-model="detailQuery.minAmount" placeholder="最小" style="width:100px" clearable type="number" :min="0" />
						<span>-</span>
						<el-input v-model="detailQuery.maxAmount" placeholder="最大" style="width:100px" clearable type="number" :min="0" />
					</div>
					<el-button type="primary" @click="resetDetailQuery">重置查询条件</el-button>
					<el-button type="primary" @click="fetchDetailData">查询</el-button>
				</div>
				
				<!-- 明细表格（对齐钱包明细的表格样式） -->
				<el-table
						:data="detailTableData"
						border
						stripe
						header-align="center"
						align="center"
						class="data-table"
				>
					<el-table-column prop="orderCode" label="订单编号" header-align="center" align="center"></el-table-column>
					<el-table-column prop="commissionAmount" label="提成金额(元)" header-align="center" align="center">
						<template slot-scope="scope">
              <span :class="scope.row.commissionAmount>0 ? 'text-success' : 'text-danger'">
                {{ scope.row.commissionAmount }}
              </span>
						</template>
					</el-table-column>
					<el-table-column prop="commissionRate" label="提成比例" header-align="center" align="center"></el-table-column>
					<el-table-column prop="nickName" label="用户名" header-align="center" align="center"></el-table-column>
					<el-table-column prop="phoneNumber" label="手机" header-align="center" align="center"></el-table-column>
					<el-table-column prop="createTime" label="系统时间" header-align="center" align="center"></el-table-column>
					<el-table-column prop="commissionType" label="类型" header-align="center" align="center">
						<template slot-scope="scope">
							<div style="padding: 5px 0">
								<div v-if="scope.row.commissionType === 1">{{ '首次消费提成'}}</div>
								<div v-else-if="scope.row.commissionType === 2">{{ '拉新者终身提成'}}</div>
								<div v-else-if="scope.row.commissionType === 3">{{ '再次通过分享链接购买'}}</div>
								<div v-else-if="scope.row.commissionType === 4">{{ '退费回补'}}</div>
								<div v-else>{{ '-' }}</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="walletTime" label="入账钱包时间" header-align="center" align="center">
						<template slot-scope="scope">
							<div>
								<div style="padding: 5px 0" v-if="scope.row.status === 2">
									{{ scope.row.updateTime }}
								</div>
								<div style="padding: 5px 0" v-else>{{ '-' }}</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="status" label="状态" header-align="center" align="center">
						<template slot-scope="scope">
							<el-tag v-if="scope.row.status===1" type="success" size="small">{{ '预估收入'  }}</el-tag>
							<el-tag v-else-if="scope.row.status===2"  size="small">{{ '已入账钱包'  }}</el-tag>
							<el-tag v-else size="small" type="info">{{ '-'  }}</el-tag>
						</template>
					</el-table-column>
				</el-table>
				
				<!-- 明细分页（对齐钱包明细的分页参数和结构） -->
				<div class="pager-box">
					<span>共{{ detailTotal }}条</span>
					<el-pagination
							:page-sizes="[20,50,100]"
							:page-size="detailPage.pageSize"
							:current-page="detailPage.pageNum"
							:total="detailTotal"
							layout="sizes, prev, pager, next, jumper"
							@size-change="detailSizeChange"
							@current-change="detailPageChange"
					/>
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
// 导入全局回车搜索功能（对齐钱包统计）
import { useEnterSearch, removeEnterSearch } from '../../../util/enterSearch';
import {getWebUserQmxfCommissionRecordsListPage, getWebUserQmxfCommissionRecordsListPageCount,getCommissionSummary} from "../../api/api";

export default {
	name: 'CommissionPage',
	data() {
		return {
			// 当前激活标签（对齐钱包统计）
			activeTab: "stat",
			
			// ========== 提成统计 ==========
			statQuery: {
				dateRange: undefined, // 日期范围（对齐钱包统计的字段名）
				minAmount: undefined,
				maxAmount: undefined
			},
			statPage: {
				pageNum: 1, // 替换原page为pageNum（对齐钱包统计）
				pageSize: 20 // 替换原size为pageSize（对齐钱包统计）
			},
			statTotal: 749,
			statTableData: [ // 统计表格模拟数据
				],
			
			// ========== 提成明细 ==========
			detailQuery: {
				orderNo: undefined,
				userName: undefined,
				phone: undefined,
				type: undefined,
				status: undefined,
				dateRange: undefined, // 日期范围（对齐钱包统计的字段名）
				minAmount: undefined,
				maxAmount: undefined
			},
			detailPage: {
				pageNum: 1, // 替换原page为pageNum（对齐钱包统计）
				pageSize: 20 // 替换原size为pageSize（对齐钱包统计）
			},
			detailTotal: 749,
			detailTableData: [],// 明细表格模拟数据
			allCount:""
		};
	},
	mounted() {
		// 使用全局回车搜索功能（对齐钱包统计）
		useEnterSearch(() => {
			if (this.activeTab === "stat") {
				this.fetchStatData();
			} else if (this.activeTab === "detail") {
				this.fetchDetailData();
			}
		});
	},
	beforeDestroy() {
		// 移除全局回车监听（对齐钱包统计）
		removeEnterSearch();
	},
	methods: {
		getCommissionSummaryFun(){
			getCommissionSummary().then(res=>{
				if(res.data.success){
					this.allCount = res.data.response;
				}
			})
		},
		
		fetchStatDataFun(){
			this.statPage.pageNum = 1;
			this.fetchStatData()
		},
		// 切换标签页重新加载数据（对齐钱包统计的changeSelectValue）
		changeSelectValue(value) {
			console.log("切换标签页：", value);
			if (value.name === "stat") {
				this.statPage.pageNum = 1;
				this.fetchStatData();
			} else if (value.name === "detail") {
				this.detailPage.pageNum = 1;
				this.fetchDetailData();
			}
		},
		
		// ========== 提成统计 ==========
		// 重置统计查询条件
		resetStatQuery() {
			this.statQuery = {
				dateRange: undefined,
				minAmount: undefined,
				maxAmount: undefined
			};
		},
		// 获取统计数据
		async fetchStatData() {
			try {
				// 封装查询参数（对齐钱包统计的参数结构）
				const params = {
					pageIndex: this.statPage.pageNum,
					pageSize: this.statPage.pageSize,
					startTime: this.statQuery.dateRange ? this.statQuery.dateRange[0] : undefined,
					endTime: this.statQuery.dateRange ? this.statQuery.dateRange[1] : undefined,
					startAmount: this.statQuery.minAmount || undefined,
					endAmount: this.statQuery.maxAmount || undefined
				};
				
				// 实际项目中替换为真实接口调用
				const res = await getWebUserQmxfCommissionRecordsListPageCount(params);
				if (res.data.success) {
					console.log("提成统计查询结果：", res.data.response);
				  this.statTableData = res.data.response.data;
				  this.statTotal = res.data.response.dataCount;
				} else {
				  this.$message.error(res.data.message || "提成统计查询失败");
				}
			} catch (error) {
				console.error("提成统计查询异常：", error);
				this.$message.error("网络异常，提成统计查询失败");
			}
		},
		// 统计分页大小变化（对齐钱包统计）
		statSizeChange(val) {
			this.statPage.pageSize = val;
			this.fetchStatData();
		},
		// 统计分页页码变化（对齐钱包统计）
		statPageChange(val) {
			this.statPage.pageNum = val;
			this.fetchStatData();
		},
		
		// ========== 提成明细 ==========
		// 设置日期范围（前一天/后一天，对齐钱包统计）
		setDateRange(num) {
			const date = new Date();
			date.setDate(date.getDate() + num);
			const y = date.getFullYear();
			const m = (date.getMonth() + 1).toString().padStart(2, "0");
			const d = date.getDate().toString().padStart(2, "0");
			const dayStr = `${y}-${m}-${d}`;
			this.detailQuery.dateRange = [dayStr, dayStr];
		},
		// 重置明细查询条件
		resetDetailQuery() {
			this.detailQuery = {
				orderNo: undefined,
				userName: undefined,
				phone: undefined,
				type: undefined,
				status: undefined,
				dateRange: undefined,
				minAmount: undefined,
				maxAmount: undefined
			};
		},
		// 获取明细数据
		async fetchDetailData() {
			try {
				// 封装查询参数（对齐钱包统计的参数结构）
				const params = {
					pageIndex: this.detailPage.pageNum,
					pageSize: this.detailPage.pageSize,
					orderCode: this.detailQuery.orderNo ? this.detailQuery.orderNo.trim() : undefined,
					nickName: this.detailQuery.userName ? this.detailQuery.userName.trim() : undefined,
					phoneNumber: this.detailQuery.phone ? this.detailQuery.phone.trim() : undefined,
					commissionType: this.detailQuery.type !== 'all' ? this.detailQuery.type : undefined,
					status: this.detailQuery.status !== 'all' ? this.detailQuery.status : undefined,
					startTime: this.detailQuery.dateRange ? this.detailQuery.dateRange[0] : undefined,
					endTime: this.detailQuery.dateRange ? this.detailQuery.dateRange[1] : undefined,
					startAmount: this.detailQuery.minAmount ? this.detailQuery.minAmount.trim() : undefined,
					endAmount: this.detailQuery.maxAmount ? this.detailQuery.maxAmount.trim() : undefined
				};
				
				// 实际项目中替换为真实接口调用
				// const res = await getCommissionDetailList(params);
				// if (res.data.success) {
				//   this.detailTableData = res.data.response.data;
				//   this.detailTotal = res.data.response.dataCount;
				// } else {
				//   this.$message.error(res.data.message || "提成明细查询失败");
				// }
				
				const res = await getWebUserQmxfCommissionRecordsListPage(params);
				if (res.data.success) {
					this.detailTableData = res.data.response.data;
					this.detailTotal = res.data.response.dataCount;
				} else {
					this.$message.error(res.data.message || "提成明细查询失败");
				}
				
			} catch (error) {
				console.error("提成明细查询异常：", error);
				this.$message.error("网络异常，提成明细查询失败");
			}
		},
		// 明细分页大小变化（对齐钱包统计）
		detailSizeChange(val) {
			this.detailPage.pageSize = val;
			this.fetchDetailData();
		},
		// 明细分页页码变化（对齐钱包统计）
		detailPageChange(val) {
			this.detailPage.pageNum = val;
			this.fetchDetailData();
		}
	},
	created() {
		this.fetchStatData();
		this.getCommissionSummaryFun()
	}
};
</script>

<style scoped>
.commission-page {
	width: 98%;
	margin: 20px auto;
	padding: 20px;
	background: #fff;
	box-sizing: border-box;
}

/* 顶部统计栏样式 */
.top-stat {
	font-size: 14px;
	color: #333;
	margin-bottom: 15px;
	line-height: 1.8;
}

/* 标签容器（对齐钱包统计） */
.tab-box {
	margin-top: 5px;
}

/* 查询区域样式（对齐钱包统计） */
.query-row {
	display: flex;
	align-items: center;
	gap: 12px;
	margin-bottom: 15px;
	flex-wrap: wrap;
}

.detail-query {
	padding: 10px;
	background: #f9f9f9;
	border-radius: 4px;
}

.query-item {
	display: flex;
	align-items: center;
	gap: 6px;
	font-size: 14px;
	color: #666;
}

.time-box {
	gap: 8px;
}

/* 表格样式（对齐钱包统计） */
.data-table {
	width: 100%;
	--el-table-header-text-color: #333;
	--el-table-row-hover-bg-color: #f5f7fa;
}

/* 金额样式 */
.text-success {
	color: #00b42a;
	font-weight: 500;
}
.text-danger {
	color: #ff0000;
	font-weight: 500;
}

/* 分页区域（对齐钱包统计） */
.pager-box {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 18px;
	font-size: 14px;
	color: #666;
}

/* 适配小屏幕 */
@media (max-width: 1200px) {
	.query-row {
		gap: 10px;
	}
	.query-item {
		margin-bottom: 10px;
	}
}
</style>